import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import TagList from './TagList';
import NewTagForm from './NewTagForm';

export default function TagOption({ itemFormData, setItemFormData, tagTypeData, completeTagData }) {
  const [showTags, setShowTags] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    if (showTags) {
      setSearchValue('')
    } else {
      setItemFormData((prevData) => ({
        ...prevData,
        tags: []
      }));
    }
  }, [setItemFormData, showTags]);

  const toggleTagVisibility = (event) => {
    event.preventDefault();
    setShowTags(!showTags);
  };

  const handleTagClick = (clickedTag) => {
    const isTagSelected = itemFormData.tags.some(tag => tag.id === clickedTag.id);
    const updatedTags = isTagSelected
      ? itemFormData.tags.filter(tag => tag.name !== clickedTag.name)
      : [...itemFormData.tags, clickedTag];
    setItemFormData((prevData) => ({
      ...prevData,
      tags: updatedTags,
    }));
    if (searchValue) {
      setSearchValue('')
    }
  };

  const handleAddTag = (newTagName, newTagTagTypes) => {
    const newTag = { id: 0, name: newTagName, tagTypes: newTagTagTypes }
    const updatedTags = newTag
      ? itemFormData.tags.includes(newTag)
        ? itemFormData.tags.filter(tag => tag.name !== newTagName)
        : [...itemFormData.tags, newTag]
      : [...itemFormData.tags];
    setItemFormData((prevData) => ({
      ...prevData,
      tags: updatedTags,
    }));
  };

  return (
    <div>
      <div>
        <button onClick={toggleTagVisibility}>
          {showTags ? 'Hide Tags' : 'Show Tags'}
        </button>
      </div>
      {showTags && (
        <div>
          <div>
            <TagList
              itemFormData={itemFormData}
              completeTagData={completeTagData}
              tagTypeData={tagTypeData}
              onTagClick={handleTagClick}
            />
          </div>
            <div>
              <NewTagForm
                completeTagData={completeTagData}
                tagTypeData={tagTypeData}
                onAddTag={handleAddTag}
              />
            </div>
        </div>
      )}
    </div>
  );
}

TagOption.propTypes = {
  itemFormData: PropTypes.object.isRequired,
  setItemFormData: PropTypes.func.isRequired,
  tagTypeData: PropTypes.array,
  completeTagData: PropTypes.array,
};
